var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"inline-flex flex-shrink-0 items-center justify-center h-8 w-8 rounded-full bg-gray-500"},[_c('span',{staticClass:"text-sm font-medium leading-none text-white"},[_vm._v(_vm._s(_vm.initials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }